import { Center, Flex } from "@chakra-ui/react";
import { CustomBox, CustomDiscount, CustomRoom } from "./roomInfo.style";
import { type RoomInfoProps } from "./roomInfo.type";

export const RoomInfo = ({ isPriceOff, name, discountRate, personOfCapacity, structure }: RoomInfoProps) => {
    return (
        <Center flexDir="column" rowGap="16px" alignItems="flex-start">
            <Flex flexDir="column" rowGap="8px">
                <CustomRoom.Name>{name}</CustomRoom.Name>
                {isPriceOff && (
                    <Flex>
                        <CustomDiscount
                            p="4px 8px"
                            border="1px solid"
                            borderRadius="8px"
                            boxSizing="border-box"
                            fontSize="16px"
                            fontWeight="300"
                            fontFamily="Pretendard Variable"
                            discountRate={discountRate}
                        >
                            특가할인 {discountRate !== 0 ? discountRate : "없음"}
                            {discountRate ? "%" : ""}
                        </CustomDiscount>
                    </Flex>
                )}
            </Flex>
            <CustomBox>
                <CustomRoom.Description>
                    기준인원 {personOfCapacity.min}인 ~ 최대인원 {personOfCapacity.max}인
                </CustomRoom.Description>
                <CustomRoom.Description>{structure}</CustomRoom.Description>
            </CustomBox>
        </Center>
    );
};
